<div class="zoom-image-wrapper">
<div class="zoom-image" id="zoom-image">
    <div class="dialog-close-button">
      <a (click)="onClose()" id="close">
        &#10006;
      </a>
    </div>
     <div class="product-image-wrapper" id="product-image">
        <button class="prev-btn" id="pre-btn" [disabled]="!leftBtn" *ngIf="leftBtn"
        >
        <img src="{{leftImage}}" alt="<" class="prev-btn-img" (click)="onPreviousClick()" >
        </button>
        <div class="image" >
            <img src="{{images}}" alt="{{images}}" class="pro-image" id="pro-image" (click)="onClickImage()" >
        </div>
        <button class="next-btn" id="nex-btn" [disabled]="!rightBtn" *ngIf="rightBtn"
            >
            <img src="{{rightImage}}" alt=">" class="next-btn-img" (click)="onNextClick()" >
        </button>
        </div>   
</div>
<div class="download-btn" id="download-btn" >
  <a  href="{{images}}" class="down-btn">
     <u >Download</u> 
          </a>
   </div>
  </div>